// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"9c49e3de","262":"a4c51404","423":"39f0ae5e","453":"c501c9c0","501":"856c9003","519":"6449813a","554":"affca60a","654":"cfd5b1e9","669":"1f6d4ff0","718":"9d778d97","858":"0d917366"}[chunkId] + ".chunk.js";
};